import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, forwardRef, inject } from '@angular/core';
import { I18NextPipe } from 'angular-i18next';
import { SmartSearchKeywordDirective, SmartSearchState } from 'mbs-ui-kit';
import { ComputerTagsFacade } from 'mbs-ui-shared@facades/computer.tags.facade';
import { SmartSearchTemplateName } from 'mbs-ui-shared@modules/smart-search-templates/models/smart-search-templates-models';
import { map } from 'rxjs';
import { SmartSearchBaseTemplateComponent } from '../base-template/smart-search-base-template.component';

@Component({
  selector: 'mbs-smart-search-tags-template',
  templateUrl: '../base-template/smart-search-base-template.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  providers: [{ provide: SmartSearchKeywordDirective, useExisting: forwardRef(() => SmartSearchTagsTemplateComponent) }],
  imports: [CommonModule]
})
export class SmartSearchTagsTemplateComponent extends SmartSearchBaseTemplateComponent {
  i18nPipe: I18NextPipe;
  tagsFacade = inject(ComputerTagsFacade);

  public tag = SmartSearchTemplateName.Tag;
  constructor() {
    const i18nPipe = inject(I18NextPipe);

    super();

    this.i18nPipe = i18nPipe;
  }
  public items = (state: SmartSearchState) =>
    this.tagsFacade.loadAllTags().pipe(
      map((values) =>
        values
          .filter((value) => (value.name ?? '').toLowerCase().includes((state.leftCaretClearValue ?? '').toLowerCase()))
          .map((value) => ({
            value: value.name,
            searchText: value.name,
            translation: null
          }))
      )
    );
}
